<template>
  <div class="body">
    <img class="guide-img"
         src="https://a.id-photo-verify.com/ali_h5_a1/cdn/baidu_pic/baidu_guide/short_pic/tutorial_step_image@3x.png" />
    <div class="foot"
         @click="back">
      <img class="foot-img"
           :src="require('@/assets/skins/'+platformInfo.skin+'/btn.png')" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(['platformInfo'])
  },
  methods: {
    back () {
      this.$router.go(-1)
    }
  },
}
</script>

<style scoped>
.foot-img {
  width: 3.05rem;
  /* height: 0.45rem; */
}
.foot {
  width: 100%;
  background-color: #ffffff;
  height: 0.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
}
.guide-img {
  width: 100%;
}
</style>
